import {
	CaseReducer,
	createAsyncThunk,
	createSlice,
	PayloadAction,
} from '@reduxjs/toolkit';
import { IThunkApiExtra, RootState } from '../store';

interface State {
	// URL (con query strings) de la última búsqueda guardada exitosamente. Mientras la ruta
	// actual coincida con esta, el botón "Guardar" queda en su estado "Guardado" y deshabilitado;
	// se resetea (queda null) apenas la ruta cambia a una distinta de la guardada.
	savedUrl: string | null;
}

export const initialState: State = {
	savedUrl: null,
};

const setSavedUrlReducer: CaseReducer<State, PayloadAction<string>> = (state, action) => {
	state.savedUrl = action.payload;
}

export const sendUserSearch = createAsyncThunk<
	{ success: boolean },
	{ email: string; url: string },
	{ extra: IThunkApiExtra }
>(
	'userSearch/sendUserSearch',
	async (request, thunkApi) => {
		const { rejectWithValue, extra } = thunkApi;
		const { services } = extra;
		const servicesList = (await services()).setupServices();
		const response = await servicesList.sendUserSearch(request);

		if (!response?.success) {
			return rejectWithValue({ url: request.url });
		}

		return { success: true };
	}
)

export const UserSearchSlice = createSlice({
	name: 'userSearch',
	initialState,
	reducers: {
		setSavedUrl: setSavedUrlReducer,
	},
	extraReducers: builder => {
		builder.addCase(sendUserSearch.rejected, (state, action) => {
			const payload = action.payload as { url: string } | undefined;
			// Solo revierte si el rechazo corresponde a la búsqueda actualmente marcada como
			// guardada (evita pisar un guardado más nuevo con el resultado de uno viejo).
			if (payload && state.savedUrl === payload.url) state.savedUrl = null;
		})
	}
})

export const { setSavedUrl } = UserSearchSlice.actions;

export const selectSavedSearchUrl = (state: RootState) => state.UserSearchState.savedUrl;
